import Datepicker from 'flowbite/lib/esm/components/datepicker/index.js';

function initDatepicker(input: HTMLInputElement): void {
    if (input.dataset.datepickerReady === 'true') {
        return;
    }
    new Datepicker(input, {
        autohide: true,
        format: 'yyyy-mm-dd',
        orientation: 'bottom right',
    });
    input.dataset.datepickerReady = 'true';
}

function initDatepickers(root: ParentNode): void {
    root.querySelectorAll<HTMLInputElement>('[data-availability-date]').forEach(initDatepicker);
}

function bindRemove(row: Element): void {
    const button = row.querySelector<HTMLButtonElement>('[data-availability-remove]');
    if (!button || button.dataset.bound === 'true') {
        return;
    }
    button.dataset.bound = 'true';
    button.addEventListener('click', () => {
        row.remove();
    });
}

function bindRangeList(list: HTMLElement): void {
    const rows = list.querySelector<HTMLElement>('[data-availability-rows]');
    const template = list.querySelector<HTMLTemplateElement>('[data-availability-template]');
    const maxInput = list.querySelector<HTMLInputElement>('[data-availability-max-index]');
    const addButton = list.querySelector<HTMLButtonElement>('[data-availability-add]');
    if (!rows || !template || !maxInput || !addButton) {
        return;
    }

    rows.querySelectorAll<HTMLElement>('[data-availability-row]').forEach(bindRemove);

    addButton.addEventListener('click', () => {
        const next = Number(maxInput.value || '-1') + 1;
        maxInput.value = String(next);
        const html = template.innerHTML.replaceAll('__INDEX__', String(next));
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html.trim();
        const row = wrapper.firstElementChild;
        if (!row) {
            return;
        }
        rows.appendChild(row);
        initDatepickers(row);
        bindRemove(row);
        const firstField = row.querySelector<HTMLElement>('input, button');
        firstField?.focus();
    });
}

export function initPersonForm(): void {
    const root = document.querySelector('[data-person-form-fields]');
    if (!root) {
        return;
    }
    initDatepickers(root);
    root.querySelectorAll<HTMLElement>('[data-availability-range-list]').forEach(bindRangeList);
}
